type HyperDxClient = {
  recordException: (error: Error) => void;
  setGlobalAttributes: (attrs: Record<string, string>) => void;
};

let client: HyperDxClient | null = null;

export function registerHyperDxClient(next: HyperDxClient): void {
  client = next;
}

export function recordHyperDxException(error: Error): void {
  client?.recordException(error);
}

export function setHyperDxUser(
  user: { id: string; email?: string | null; name?: string | null } | null,
): void {
  if (!client) {
    return;
  }

  if (!user) {
    client.setGlobalAttributes({
      userId: '',
      userEmail: '',
      userName: '',
    });
    return;
  }

  client.setGlobalAttributes({
    userId: user.id,
    userEmail: user.email ?? '',
    userName: user.name ?? '',
  });
}
